import axios from "axios";

export const state = {
    onlinepayments: [],
};

export const getters = {
    onlinepayments: state => state.onlinepayments,
};

export const mutations = {
    setOnlinePayments(state, newValue) {
        state.onlinepayments = newValue
    },
};

export const actions = {
    fetchOnlinePayments({ commit }) {
        axios.get('/onlinepayments').then(res => {
            commit('setOnlinePayments', res.data.onlinepayments);
        })
    },
    filterOnlinePayments({commit}, {date}) { 
        let formData = new FormData();
        formData.append("date", date);
        let url = "/filteronlinepayments";
        axios.post(url, formData).then((response) => {
            commit('setOnlinePayments', response.data.onlinepayments)
        })
    },
};
